import React from "react";
import { useState } from "react";

const MentorTalkCard = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);

  return (
    <div className="testimonial-item" style={{backgroundColor : "#1D1D25", border : "1px solid white" , maxWidth : isMobile && 290 , marginLeft : isMobile && 20}}>
      <div className="testimonial-content" style={
        { marginTop :isMobile && 0}
      } >
        <p style={{color  :"white"}}>{props.item.desc}</p>
      </div>
      <div className="testimonial-info">
        <div className="thumb">
          <img
            src={props.item.src}
            alt=""
            style={{scale : "1.6" , border :"3px solid white"}}
          />
        </div>
        <div className="content">
          <h4 className="title" style={{color  :"white"}}>{props.item.title}</h4>
          <p style={{color  :"white"}}>{props.item.designation}</p>
        </div>
      </div>
    </div>
  );
};

export default MentorTalkCard;
